// React
import React from 'react';
import { useHistory } from 'react-router-dom';

// Yup validation
import * as Yup from 'yup';
import { useFormik } from 'formik';

// Containers Injection
import { notifyError } from '../../containers/componentsInjection';

// View
import ExportPharmaPage from './view';

// Utils
import { useLoading } from '../../../../hook/useLoading';
import { APIClient } from '../../../../helpers/api_helper';
import { openPdfWithBase64 } from '../../../../utils/openPdfWithBase64';

export const ExportPharma = () => {
  const api = new APIClient();
  const history = useHistory();
  const { toggleLoading, setLoading } = useLoading();

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      startPeriod: '',
      endPeriod: '',
    },
    validationSchema: Yup.object({
      startPeriod: Yup.string().required(),
      endPeriod: Yup.string().required(),
    }),

    onSubmit: (values) => {
      const valuesToSubmit = {
        starts: values.startPeriod || null,
        ends: values.endPeriod || null,
      };

      toggleLoading();
      api
        .create('/services/export-pharmacy', valuesToSubmit)
        .then((response) => {
          const linkSource = `data:text/plain;base64, ${response.data}`;
          const downloadLink = document.createElement('a');
          const fileName = 'exportacao.xlsx';
          downloadLink.href = linkSource;
          downloadLink.download = fileName;
          downloadLink.click();
        })
        .catch((error) => {
          notifyError(error.response.data.messages.error);
        })
        .finally(() => {
          setLoading(false);
        });
    },
  });

  return <ExportPharmaPage history={history} validation={validation} />;
};
